import type { RootState } from 'store'

export const getSort = (state: RootState) =>
  state?.retailGeoIndications?.sorting
export const getPageInfo = (state: RootState) =>
  state?.retailGeoIndications?.pageInfo ?? null
export const getLoading = (state: RootState) =>
  state?.retailGeoIndications?.loading
export const getError = (state: RootState) => state?.retailGeoIndications?.error
export const getItems = (state: RootState) => state?.retailGeoIndications?.items
export const getQuery = (state: RootState) =>
  state?.retailGeoIndications?.query ?? ''
export const getFilters = (state: RootState) =>
  state?.retailGeoIndications?.filters ?? []
export const getSelectedItems = (state: RootState) =>
  state?.retailGeoIndications?.selectedItems || []
export const getMerchant = (state: RootState) =>
  state?.retailGeoIndications?.merchant ?? null
